export default function timeToNumber(time) {
  const [hour, minute] = time.split(':');
  return (hour * 60) + +minute;
}
